import { ArrowLeft, LockKey, Wrench } from "@phosphor-icons/react";

import { WorkspaceLink } from "./WorkspaceLink";

const labels: Record<string, string> = {
  "/app/orders": "Orders",
  "/app/products": "Products",
  "/app/flows": "Flows",
  "/app/broadcasts": "Broadcasts",
  "/app/sequences": "Sequences",
  "/app/triggers": "Triggers",
  "/app/tools": "Tools",
};

export function WorkspacePlannedPage({ path }: { path: string }) {
  const label = labels[path] ?? "Workspace tool";

  return (
    <main className="workspace-planned-page">
      <div className="planned-page-icon" aria-hidden="true">
        <Wrench weight="bold" />
      </div>
      <span className="workspace-eyebrow">Nkuli workspace</span>
      <h1>{label}</h1>
      <p>
        {label} is planned for a later product slice. This destination is not
        connected to live business workflows yet.
      </p>
      <span className="planned-page-note">
        <LockKey weight="bold" /> Planned, not active
      </span>
      <WorkspaceLink className="workspace-back-link" href="/app">
        <ArrowLeft weight="bold" /> Return to Home
      </WorkspaceLink>
    </main>
  );
}
